import * as React from "react";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import RestoreIcon from "@mui/icons-material/Restore";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Link, useLocation } from "react-router-dom";
import BackPageButton from "./BackPageButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";

export default function SimpleBottomNavigation() {
  const [value, setValue] = React.useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };

  const isRootPath =
    location.pathname === "/" ||
    location.pathname === "/patient/familylist" ||
    location.pathname === "/patient/appointmentConfirmation";

  const navigationActions = [
    !isRootPath && (
      <BottomNavigationAction
        key="back"
        label="Back"
        icon={<ArrowBackIosIcon />}
        onClick={handleGoBack}
      />
    ),
    <BottomNavigationAction
      key="familyList"
      label="Family List"
      icon={<RestoreIcon />}
      component={Link}
      to="/patient/familylist"
      state={location.state || {}}
    />,
    <BottomNavigationAction
      key="appointment"
      label="Appointment"
      // component={Link}
      // to="/patient/appointments"
      icon={<FavoriteIcon />}
    />,
    <BottomNavigationAction
      key="profile"
      label="Profile"
      component={Link}
      to="/patient/profile"
      icon={<LocationOnIcon />}
    />,
  ];

  return (
    <Box
      sx={{ width: "100%" }}
      className=" fixed bottom-0 left-0 drop-shadow-2xl "
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
      >
        {navigationActions}
      </BottomNavigation>
    </Box>
  );
}
